import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import './Admin.css';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    titleJapanese: '',
    description: '',
    level: 'N5',
    category: 'General'
  });

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await api.get('/admin/courses');
      setCourses(response.data.courses);
    } catch (error) {
      console.error('コース取得エラー:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateCourse = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/courses', formData);
      setShowModal(false);
      resetForm();
      fetchCourses();
      alert('コースを作成しました');
    } catch (error) {
      alert(error.response?.data?.error || 'エラーが発生しました');
    }
  };

  const handleDeleteCourse = async (courseId, courseTitle) => {
    if (!window.confirm(`「${courseTitle}」を削除してもよろしいですか？\n関連するレッスンも全て削除されます。`)) {
      return;
    }
    try {
      await api.delete(`/admin/courses/${courseId}`);
      fetchCourses();
      alert('コースを削除しました');
    } catch (error) {
      alert('削除できませんでした');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      titleJapanese: '',
      description: '',
      level: 'N5',
      category: 'General'
    });
  };

  if (loading) {
    return <div className="loading">読み込み中...</div>;
  }

  return (
    <div className="admin-courses">
      <div className="page-header">
        <h1>コース管理</h1>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + 新規コース作成
        </button>
      </div>

      <div className="courses-grid">
        {courses.length > 0 ? (
          courses.map(course => (
            <div key={course.id} className="course-card-admin">
              <div className="course-header">
                <span className={`level-badge level-${course.level}`}>{course.level}</span>
                <span className="category-badge">{course.category || 'General'}</span>
              </div>
              <h3>{course.title}</h3>
              {course.title_japanese && (
                <p className="title-jp">{course.title_japanese}</p>
              )}
              <p className="description">{course.description || '説明なし'}</p>
              <div className="course-meta">
                <span>📚 {course.lesson_count || 0} レッスン</span>
                {course.creator_name && (
                  <span>👤 {course.creator_name}</span>
                )}
              </div>
              <div className="course-actions">
                <button 
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDeleteCourse(course.id, course.title)}
                >
                  削除
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data-card">
            <p>コースがありません</p>
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              最初のコースを作成
            </button>
          </div>
        )}
      </div>

      {/* コース作成モーダル */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>新規コース作成</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleCreateCourse}>
              <div className="form-group">
                <label>コースタイトル（英語） *</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={e => setFormData({...formData, title: e.target.value})}
                  required
                  placeholder="N5 Basic Japanese"
                />
              </div>
              <div className="form-group">
                <label>コースタイトル（日本語）</label>
                <input
                  type="text"
                  value={formData.titleJapanese}
                  onChange={e => setFormData({...formData, titleJapanese: e.target.value})}
                  placeholder="N5 基礎日本語"
                />
              </div>
              <div className="form-group">
                <label>説明</label>
                <textarea
                  value={formData.description}
                  onChange={e => setFormData({...formData, description: e.target.value})}
                  placeholder="コースの内容や目標を説明してください"
                  rows={3}
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>レベル *</label>
                  <select
                    value={formData.level}
                    onChange={e => setFormData({...formData, level: e.target.value})}
                  >
                    <option value="N5">N5 (初級)</option>
                    <option value="N4">N4</option>
                    <option value="N3">N3 (中級)</option>
                    <option value="N2">N2</option>
                    <option value="N1">N1 (上級)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>カテゴリ</label>
                  <select
                    value={formData.category}
                    onChange={e => setFormData({...formData, category: e.target.value})}
                  >
                    <option value="General">一般</option>
                    <option value="Conversation">会話</option>
                    <option value="Grammar">文法</option>
                    <option value="Business">ビジネス</option>
                    <option value="JLPT">JLPT対策</option>
                  </select>
                </div>
              </div>
              <div className="form-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  キャンセル
                </button>
                <button type="submit" className="btn btn-primary">
                  作成
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Courses;
